// Board Reports Redux action types

export const GET_BOARD_REPORTS_REQUEST = "GET_BOARD_REPORTS_REQUEST";
export const GET_BOARD_REPORTS_SUCCESS = "GET_BOARD_REPORTS_SUCCESS";
export const GET_BOARD_REPORTS_FAIL = "GET_BOARD_REPORTS_FAIL";

export const CLEAR_BOARD_REPORTS = "CLEAR_BOARD_REPORTS";
